module.exports = __webpack_public_path__ + "img/handler-wrong.c8a613d2.png";